import { field_dark_theme } from 'framework/field/constants';
import { font_theme } from 'framework/theme/constants/font';

import { CheckboxTheme } from './types';

export const checkbox_theme: Pick<CheckboxTheme, 'general'> = {
  general: {
    icon_size: font_theme.general.font_size_small,
    font_family: font_theme.general.font_family,
    font_size: font_theme.general.font_size_normal,
    gap: '8px',
  },
};

export const checkbox_dark_theme: CheckboxTheme = {
  general: checkbox_theme.general,
  color: {
    normal: field_dark_theme.color.normal,
    active: field_dark_theme.color.active,
    hover: field_dark_theme.color.hover,
    disabled: field_dark_theme.color.disabled,
  },
};
